var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase4Line = function SvgBriefcase4Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 5.7V3a.9.9 0 0 1 .9-.9h7.2a.9.9 0 0 1 .9.9v2.7h3.6a.9.9 0 0 1 .9.9v12.6a.9.9 0 0 1-.9.9H4.4a.9.9 0 0 1-.9-.9V6.6a.9.9 0 0 1 .9-.9zm1.8 7.2H5.3v5.4h14.4v-5.4h-4.5v2.7H9.8zm9.9-5.4H5.3v3.6h4.5V9.3h5.4v1.8h4.5zm-8.1 3.6v2.7h1.8v-2.7zM9.8 3.9v1.8h5.4V3.9z"
  })));
};
export default SvgBriefcase4Line;